import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination } from '@mui/material';
import { useState } from 'react';
import UpdateDriver from './updateDriver';

const columns = [
    { id: 'id', label: 'ID', minWidth: 30 },
    { id: 'name', label: 'Name', minWidth: 120 },
    { id: 'plateNo', label: 'Plate No', minWidth: 120 },
    { id: 'rating', label: 'Rating', minWidth: 120 },
    { id: 'carTypeName', label: 'Car Type Name', minWidth: 120 },
    { id: 'active', label: 'Active', minWidth: 120 },
    { id: 'currentStatusName', label: 'Current Status Name', minWidth: 120 },
    { id: 'startWorkDateTime', label: 'Start Work Date', minWidth: 120, type: 'date' },
    { id: 'endWorkDateTime', label: 'End Work Date', minWidth: 120, type: 'date' },
    { id: 'createdDate', label: 'Created Date', minWidth: 120, type: 'date' },
    { id: 'createdBy', label: 'Created By', minWidth: 120 },
];

function StickyHeadTable({ drivers,fetchDriversRecord,driverCarTypeID,driverCurrentStatus}) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {drivers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        let value = row[column.id];
                                        if (column.type && column.type === 'date') {
                                            if (value) {
                                                const timeString12hr = new Date(
                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                });
                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                            }
                                        }
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {typeof value === 'boolean'
                                                    ? value.toString()
                                                    : column.format && typeof value === 'number'
                                                    ? column.format(value)
                                                    : value}
                                                {/* {column.format && typeof value === 'number' ? column.format(value) : value} */}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            <UpdateDriver
                                                driverList={row}
                                                fetchDriversRecord={fetchDriversRecord}
                                                driverCarTypeID={driverCarTypeID}
                                                driverCurrentStatus={driverCurrentStatus}
                                            />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={drivers.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default StickyHeadTable;
